import { Button, Screen, Text } from "components"
import React, { useEffect, useState } from "react"
import { Image, TouchableOpacity, View, useWindowDimensions } from "react-native"
import { style } from "./styles"
import { useNavigation, useRoute } from "@react-navigation/native"
import { translate } from "i18n"
import Icon from "@expo/vector-icons/MaterialIcons"
import MaterialCommunityIcons from "@expo/vector-icons/MaterialCommunityIcons"
import flash from "config/flash"
import { colors } from "colors"
import Modal from "react-native-modal"
import QRCode from "react-native-qrcode-svg"
import moment from "moment-timezone"
import { useSessionExpired } from "utils/function"
import { useStores } from "models"
import RenderHTML from "react-native-render-html"
import { useColor } from "app/theme/getThemes"
import { BarcodeComponent } from "components/Barcode"
import { typography } from "theme"
import { upperCase } from "lodash"

import Clipboard from "@react-native-clipboard/clipboard"

export const VoucherDetailScreen = () => {
  const navigation = useNavigation<any>()
  const route = useRoute()
  const { routeFrom, item }: any = route?.params || {}
  const { height, width } = useWindowDimensions()
  const [isTncOpen, setIsTncOpen] = useState(false)
  const [isRedeemOpen, setIsRedeemOpen] = useState(false)
  const [data] = useState(item)
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false)
  const { sessionExpired } = useSessionExpired()
  const { userStore } = useStores()
  const [point, setPoint] = useState(userStore?.totalPoint || 0)
  const [isUserUseVoucher, setIsUserUseVoucher] = useState(!!item?.use_at)
  const [countdown, setCountdown] = useState(-1)
  const [isVoucherExpired, setIsVoucherExpired] = useState(() => {
    const now = moment().tz("Asia/Kuala_Lumpur")
    if (item?.use_at && now.isAfter(moment(item.use_at).add(15, "minutes"))) {
      return true
    }
    if (item?.voucher_expire_at) {
      return now.isAfter(moment(item.voucher_expire_at))
    }
    if (item?.end_date) {
      return now.isAfter(moment(item.end_date))
    }
    return false
  })
  const type = item?.voucher_barcode ? "redeemed" : "unredeemed"
  const voucherType =
    item?.voucher_type === "coupon" || item?.voucher_type === "brand_voucher" ? "coupon" : "voucher"

  const voucherRequiredPoint = item?.voucher_point_required || 0
  const oldBalance = userStore?.totalPoint || 0
  const newBalance = oldBalance - voucherRequiredPoint
  const [balanceChange, setBalanceChange] = useState({ old: 0, new: 0 })
  const [codeType, setCodeType] = useState("barcode")

  useEffect(() => {
    setBalanceChange({ old: oldBalance, new: newBalance })
  }, [oldBalance, voucherRequiredPoint])

  const getUserPoint = async () => {
    await fetch(`${process.env.API_URL}/api/client/pointbal`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        if (res?.ok) {
          const responseData = await res?.json()
          setPoint(responseData?.data)
          userStore?.update({
            totalPoint: responseData?.data,
          })
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          }
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }

  useEffect(() => {
    routeFrom === "view" && getUserPoint()
  }, [])

  const redeemVoucher = async () => {
    await fetch(`${process.env.API_URL}/api/voucher_list/redeem`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
      body: JSON.stringify({
        voucher_id: data?.voucher_catalog_id,
        member_id: userStore?.id,
      }),
    })
      .then(async (res) => {
        if (res?.ok) {
          await getUserPoint()
          onCloseModal()
          navigation.goBack()
          flash("success", translate("voucherDetailScreen.redeemSuccesfully"))
        } else {
          onCloseModal()

          const errorMsg = await res?.json()

          if (errorMsg?.message === "Token expired" || errorMsg?.message === "Invalid token") {
            sessionExpired()
          } else if (errorMsg?.message === "Error redeem voucher. No stock is available.") {
            flash("error", translate("errors.outOfStock"))
          } else if (
            errorMsg?.message === "Error redeem voucher. Balance is not enough to redeem."
          ) {
            flash("error", translate("errors.notEnoughPoint"))
          } else {
            flash("error", translate("errors.failedToRedeemNoVoucher"))
          }
        }
      })
      .catch((e) => {
        flash("error", translate("errors.failedToRedeemNoVoucher"))
        console.error(e)
      })
  }

  useEffect(() => {
    if (isUserUseVoucher && item?.use_at) {
      const expirationTime = moment(item?.use_at).add(15, "minutes")
      const countdownSeconds = expirationTime.diff(moment(), "seconds")
      setCountdown(countdownSeconds)
    }
  }, [isUserUseVoucher, item?.use_at])

  useEffect(() => {
    let timer

    if (countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prev) => prev - 1)
      }, 1000)
    } else if (countdown === 0) {
      onCloseModal()
      setIsVoucherExpired(true)
      flash("error", "Voucher Expired")
    }

    return () => clearInterval(timer)
  }, [countdown])

  const formatCountdown = () => {
    const minutes = Math.floor(countdown / 60)
    const seconds = countdown % 60
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
  }

  const onCloseModal = () => {
    setIsModalVisible(false)
  }

  const userUseVoucher = async () => {
    await fetch(`${process.env.API_URL}/api/voucher_list/redeem`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
      body: JSON.stringify({
        voucher_id: item?.voucher_catalog_id,
        voucher_barcode: item?.voucher_barcode,
        redeem_by: userStore?.id,
      }),
    })
      .then(async (res) => {
        if (res?.ok) {
          flash("success", translate("voucherDetailScreen.useVoucherSuccessfully"))
          setCountdown(900)
          setIsUserUseVoucher(true)
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          } else {
            onCloseModal()
            flash("error", translate("errors.failedToUseVoucher"))
          }
        }
      })
      .catch((e) => {
        onCloseModal()
        flash("error", translate("errors.failedToUseVoucher"))
        console.error(e)
      })
  }

  const { companyTheme } = useColor()

  console.log(item, "item")

  const Accordion = ({ type, text }: { type: "redeem" | "tnc"; text: string }) => {
    const openAccordion = type === "redeem" ? isRedeemOpen : isTncOpen
    const setOpenAccordion = type === "redeem" ? setIsRedeemOpen : setIsTncOpen

    return (
      <View style={style.accordionContainer}>
        <TouchableOpacity
          onPress={() => {
            setOpenAccordion(!openAccordion)
          }}
          style={style.accordionTitleContainer}
        >
          <Text>
            {type === "redeem"
              ? translate("voucherDetailScreen.howToUse")
              : translate("promotionDetailScreen.tnc")}
          </Text>
          {openAccordion ? (
            <MaterialCommunityIcons name="chevron-up" size={24} color={companyTheme.first} />
          ) : (
            <MaterialCommunityIcons name="chevron-down" size={24} color={companyTheme.first} />
          )}
        </TouchableOpacity>
        {openAccordion && (
          <>
            <View style={style.accordionContentContainer} />
            <RenderHTML
              tagsStyles={{
                div: { marginTop: 0, marginBottom: 0 },
                p: {
                  marginTop: 0,
                  marginBottom: 0,
                  fontSize: 14,
                  width: "100%",
                  textAlign: "left",
                },
                strong: { fontWeight: "bold", marginBottom: 10 },
                em: { fontStyle: "italic" },
              }}
              source={{
                html: text,
              }}
            />
          </>
        )}
      </View>
    )
  }

  const [isCopied, setIsCopied] = useState(false)

  const copyToClipboard = () => {
    Clipboard.setString(item?.voucher_barcode)
    setIsCopied(true)
  }

  return (
    <>
      <Screen preset="scroll" contentContainerStyle={style.scrollContent}>
        <View>
          <View
            style={{
              height: width * 0.6,
              maxHeight: height * 0.4,
              backgroundColor: companyTheme.second,
            }}
          >
            <Image
              source={{
                uri: data?.voucher_image,
              }}
              style={[style.image, { height: "100%", width: "100%", resizeMode: "contain" }]}
            />
            <TouchableOpacity onPress={() => navigation.goBack()} style={style.headerLeftButton}>
              <Icon name="arrow-back" size={28} color="white" />
            </TouchableOpacity>
          </View>
          <View style={style.container}>
            <Text style={style.title}>{data?.voucher_name}</Text>

            {item?.start_date && item?.end_date ? (
              <View style={style.calendarContainer}>
                <MaterialCommunityIcons
                  name="calendar-month"
                  size={28}
                  color={companyTheme.first}
                />
                {!item?.voucher_barcode ? (
                  <Text style={style.dateText}>
                    {moment(item?.start_date).format("DD-MMM-YYYY")} -{" "}
                    {moment(item?.end_date).format("DD-MMM-YYYY")}
                  </Text>
                ) : (
                  <Text style={style.dateText}>
                    Expires at : {moment(item?.voucher_expire_at).format("DD-MMM-YYYY")}
                  </Text>
                )}
              </View>
            ) : (
              <View style={style.calendarContainer}>
                <MaterialCommunityIcons
                  name="calendar-month"
                  size={28}
                  color={companyTheme.first}
                />

                <Text style={style.dateText}>
                  {translate("voucherScreen.expiredOn")} -{" "}
                  {moment(item?.voucher_expired_at).format("DD-MM-YYYY")}
                </Text>
              </View>
            )}

            <View
              style={{
                width: "100%",
                justifyContent: "space-between",
                display: "flex",
                flexDirection: "row",
              }}
            >
              {/* <Text style={style.description}>
                {item?.voucher_description?.replace(/<[^>]*>/gim, "")}
              </Text> */}
              <View
                style={{ width: `${item?.voucher_point_required ? "80%" : "100%"}`, marginTop: 10 }}
              >
                <RenderHTML
                  tagsStyles={{
                    div: { marginTop: 0, marginBottom: 0 },
                    p: {
                      marginTop: 0,
                      marginBottom: 0,
                      fontSize: 14,
                      width: "100%",
                      textAlign: "left",
                    },
                    strong: { fontWeight: "bold", marginBottom: 10 },
                    em: { fontStyle: "italic" },
                  }}
                  source={{
                    html: item?.voucher_description || "",
                  }}
                />
              </View>
            </View>

            {item?.voucher_point_required > 0 && !item?.voucher_barcode && (
              <Text style={[style.description, { color: colors.buttonBackground, marginTop: 10 }]}>
                {item?.voucher_point_required} pts
              </Text>
            )}

            {/* Accordian dropdown */}

            <Accordion type="redeem" text={item?.voucher_how_to_redeem} />
            <Accordion type="tnc" text={item?.voucher_tnc} />
          </View>
          {/* Sticky bottom */}
        </View>
      </Screen>
      <View
        style={[
          style.stickyBottomContainer,
          routeFrom === "history"
            ? !isVoucherExpired
              ? {}
              : {
                  backgroundColor: colors.background,
                }
            : {},
        ]}
      >
        {routeFrom === "history" || isVoucherExpired ? (
          !isVoucherExpired ? (
            <Button
              onPress={() => {
                setIsModalVisible(true)
              }}
              title={translate("voucherDetailScreen.useCoupon")}
              style={style.buttonContainer}
              titleStyle={style.buttonText}
            />
          ) : (
            <Text style={style.usedExpiredText}>
              {item?.use_at
                ? translate("voucherDetailScreen.usedOn")
                : translate("voucherDetailScreen.expiredOn")}{" "}
              {moment(
                item?.use_at
                  ? item?.use_at
                  : item?.voucher_expire_at
                  ? item?.voucher_expire_at
                  : item?.end_date,
              ).format("DD-MM-YYYY • hh:mm a")}
            </Text>
          )
        ) : !item?.voucher_barcode && Number(item?.remaining_voucher || 0) <= 0 ? (
          <Text style={style.usedExpiredText}>
            There are no more vouchers available for this promotion, please check back later
          </Text>
        ) : (
          <>
            {type === "redeemed" && (
              <Text style={style.dontClickText}>
                {translate("voucherDetailScreen.dontClickCoupon")}
              </Text>
            )}
            <Button
              onPress={() => {
                if (point < item?.voucher_point_required && routeFrom === "view") {
                  flash("error", translate("errors.notEnoughPoint"))
                } else {
                  setIsModalVisible(true)
                }
              }}
              title={
                type === "unredeemed"
                  ? translate(
                      item?.voucher_type === "redemption"
                        ? "voucherDetailScreen.redeem"
                        : "voucherDetailScreen.claim",
                    )
                  : translate("voucherDetailScreen.useVoucher")
              }
              style={style.buttonContainer}
              titleStyle={style.buttonText}
            />
          </>
        )}
      </View>

      <Modal
        isVisible={isModalVisible}
        onBackdropPress={() => {
          onCloseModal()
        }}
        onBackButtonPress={() => {
          onCloseModal()
        }}
      >
        <View
          style={[
            style.modalContainer,
            data?.voucher_type === "brand_voucher" &&
              type === "redeemed" && { backgroundColor: companyTheme.second },
          ]}
        >
          {data?.voucher_type === "brand_voucher" && type === "redeemed" && (
            <Text
              style={{
                fontSize: 30,
                fontFamily: typography.primary.normal,
                fontWeight: "bold",
                marginBottom: 20,
                color: colors.white,
              }}
            >
              {upperCase(process.env.COMPANY_CODE)} Voucher
            </Text>
          )}
          {!isUserUseVoucher ? (
            <>
              <Text>
                {type === "redeemed"
                  ? translate("voucherDetailScreen.areYouSureUse")
                  : item?.voucher_type === "redemption"
                  ? translate("voucherDetailScreen.areYouSureRedeem")
                  : "Are you sure you want to claim?"}
              </Text>

              {voucherRequiredPoint > 0 && type === "unredeemed" && (
                <View style={style.oldNewBalContainer}>
                  <View style={style.balanceRow}>
                    <Text style={style.balanceLabelOld}>Old Balance:</Text>
                    <Text style={style.balanceValueOld}>{balanceChange.old}</Text>
                  </View>

                  <View style={style.balanceRow}>
                    <Text style={style.balanceLabelNew}>New Balance:</Text>
                    <Text style={style.balanceValueNew}>{balanceChange.new}</Text>
                  </View>
                </View>
              )}
              <View style={style.redeemModalContainer}>
                <Button
                  onPress={() => onCloseModal()}
                  title={
                    type === "redeemed"
                      ? translate("voucherDetailScreen.useLater")
                      : item?.voucher_type === "redemption"
                      ? translate("voucherDetailScreen.redeemLater")
                      : "Claim Later"
                  }
                  style={[style.redeemLaterButton, { borderColor: companyTheme.first }]}
                  titleStyle={{
                    color: companyTheme.first,
                  }}
                />
                <Button
                  onPress={() => {
                    type === "redeemed" ? userUseVoucher() : redeemVoucher()
                  }}
                  title={
                    type === "redeemed"
                      ? translate("voucherDetailScreen.use")
                      : translate(
                          item?.voucher_type === "redemption"
                            ? "voucherDetailScreen.redeem"
                            : "voucherDetailScreen.claim",
                        )
                  }
                  style={style.flex}
                />
              </View>
            </>
          ) : (
            <>
              {item?.voucher_type === "partner_voucher" ? (
                <>
                  <Text style={{ textAlign: "center", fontSize: 16, marginBottom: 10 }}>
                    Your voucher code:
                  </Text>
                  <TouchableOpacity
                    onPress={copyToClipboard}
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                      borderRadius: 10,
                      padding: 10,
                      width: "100%",
                      borderWidth: 1,
                      borderColor: "black",
                    }}
                  >
                    <Text style={{ fontSize: 16, marginRight: 10 }}>{item?.voucher_barcode}</Text>
                    <MaterialCommunityIcons name="content-copy" size={24} color="black" />
                  </TouchableOpacity>
                  {isCopied && (
                    <Text style={{ textAlign: "center", marginTop: 10, color: "green" }}>
                      Copied to clipboard!
                    </Text>
                  )}

                  <Text style={style.qrExpiredText}>
                    {"Code will be expired in"}{" "}
                    <Text style={{ color: companyTheme.first }}>{formatCountdown()}</Text>
                  </Text>
                  <Button
                    onPress={() => {
                      onCloseModal()
                    }}
                    style={{ marginTop: 20 }}
                    title={translate("common.ok")}
                  />
                </>
              ) : (
                <>
                  <TouchableOpacity
                    onPress={() => setCodeType(codeType === "barcode" ? "qr" : "barcode")}
                  >
                    {codeType === "barcode" ? (
                      <>
                        <BarcodeComponent
                          format="CODE128"
                          value={`${item?.voucher_catalog_id}-${item?.voucher_barcode}`}
                          width={1.5}
                        />
                      </>
                    ) : (
                      <QRCode
                        size={150}
                        value={`${item?.voucher_catalog_id}-${item?.voucher_barcode}`}
                      />
                    )}
                    {codeType === "qr" && (
                      <Text
                        style={{ alignSelf: "center", marginTop: 10 }}
                      >{`${item?.voucher_catalog_id}-${item?.voucher_barcode}`}</Text>
                    )}
                  </TouchableOpacity>
                  <Text style={style.qrExpiredText}>
                    {translate("voucherDetailScreen.clickToShowBarCode")}{" "}
                    {codeType === "barcode" ? "QR Code" : "barcode"}
                  </Text>

                  <View style={style.dividerView}>
                    <View
                      style={[
                        style.dividerViewStyle,
                        data?.voucher_type === "brand_voucher" &&
                          type === "redeemed" && { backgroundColor: companyTheme.second },
                      ]}
                    />
                  </View>

                  <Text style={style.qrExpiredText}>
                    {translate("voucherDetailScreen.expiredIn")}{" "}
                    <Text style={{ color: companyTheme.first }}>{formatCountdown()}</Text>
                  </Text>

                  <Button
                    onPress={() => {
                      onCloseModal()
                    }}
                    style={style.mt30}
                    title={translate("common.ok")}
                  />
                </>
              )}
            </>
          )}
        </View>
      </Modal>
    </>
  )
}
